import { Radio } from "antd";
import React from "react";
import styles from "./results.scss";
import { RealEstatePricesUserTypeValues } from "../../models";
import history from "../../history";

export const RealEstatePricesFilter = ({ selectedUserType }) => {
  const onChange = e => {
    history.push(`?userType=${e.target.value}`);
  };

  const FilterByOptions = [
    { label: "Svi oglasi", value: RealEstatePricesUserTypeValues.ALL_USERS },
    { label: "Oglasi privatnih korisnika", value: RealEstatePricesUserTypeValues.PRIVATE_USERS },
    { label: "Oglasi poslovnih korisnika", value: RealEstatePricesUserTypeValues.BUSINESS_USERS }
  ];

  return (
    <Radio.Group onChange={onChange} value={selectedUserType} className={styles.realEstatePricesFilter}>
      {FilterByOptions.map(option => (
        <Radio key={option.label} value={option.value}>{option.label}</Radio>
      ))}
    </Radio.Group>
  );
};



// WEBPACK FOOTER //
// ./src/containers/RealEstatePricesPage/RealEstatePricesFilter.tsx